import { render } from "./CompanyObjectDisplay.vue?vue&type=template&id=74beac6a&scoped=true&ts=true"
import script from "./CompanyObjectDisplay.vue?vue&type=script&lang=ts"
export * from "./CompanyObjectDisplay.vue?vue&type=script&lang=ts"

import "./CompanyObjectDisplay.vue?vue&type=style&index=0&id=74beac6a&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74beac6a"]])

export default __exports__